import { render } from "./homeManagerCenter.vue?vue&type=template&id=21f9edf6&scoped=true"
import script from "./homeManagerCenter.vue?vue&type=script&lang=js"
export * from "./homeManagerCenter.vue?vue&type=script&lang=js"

import "./homeManagerCenter.vue?vue&type=style&index=0&id=21f9edf6&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f9edf6"]])

export default __exports__